var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Fill/eye"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.5016C11.173 10.5016 10.5 11.1746 10.5 12.0016C10.5 12.8286 11.173 13.5016 12 13.5016C12.827 13.5016 13.5 12.8286 13.5 12.0016C13.5 11.1746 12.827 10.5016 12 10.5016ZM12 15.5016C10.07 15.5016 8.5 13.9316 8.5 12.0016C8.5 10.0716 10.07 8.5016 12 8.5016C13.93 8.5016 15.5 10.0716 15.5 12.0016C15.5 13.9316 13.93 15.5016 12 15.5016ZM21.868 11.5036C21.229 10.3916 17.706 4.8176 11.729 5.0046C6.202 5.1456 2.986 10.0156 2.132 11.5036C1.956 11.8126 1.956 12.1906 2.132 12.4996C2.762 13.5966 6.162 19.0016 12.025 19.0016C12.106 19.0016 12.188 19.0006 12.271 18.9986C17.798 18.8576 21.014 13.9876 21.868 12.4996C22.044 12.1906 22.044 11.8126 21.868 11.5036Z",
    fill: "#2062F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_219_4563",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 5,
    width: 20,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.5016C11.173 10.5016 10.5 11.1746 10.5 12.0016C10.5 12.8286 11.173 13.5016 12 13.5016C12.827 13.5016 13.5 12.8286 13.5 12.0016C13.5 11.1746 12.827 10.5016 12 10.5016ZM12 15.5016C10.07 15.5016 8.5 13.9316 8.5 12.0016C8.5 10.0716 10.07 8.5016 12 8.5016C13.93 8.5016 15.5 10.0716 15.5 12.0016C15.5 13.9316 13.93 15.5016 12 15.5016ZM21.868 11.5036C21.229 10.3916 17.706 4.8176 11.729 5.0046C6.202 5.1456 2.986 10.0156 2.132 11.5036C1.956 11.8126 1.956 12.1906 2.132 12.4996C2.762 13.5966 6.162 19.0016 12.025 19.0016C12.106 19.0016 12.188 19.0006 12.271 18.9986C17.798 18.8576 21.014 13.9876 21.868 12.4996C22.044 12.1906 22.044 11.8126 21.868 11.5036Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_219_4563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x8E\xA8 Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    fill: "#2062F4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.5421a798fb19999eaf5a046e3fd5eb37.svg";
export { ForwardRef as ReactComponent };